<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_5"></a>CONTENTS</h2>
<p class="imagec"><img alt="Illustration" src="images/common.jpg"/></p>
<p class="toc"><span href="#/xhtml/chapter01#ch1" title="Link target outside of Sample">Across the Millenia</span></p>
<p class="toc"><span href="#/xhtml/chapter02#ch2" title="Link target outside of Sample">Gift of the Nile</span></p>
<p class="toc"><span href="#/xhtml/chapter03#ch3" title="Link target outside of Sample">Glorious Sun</span></p>
<p class="toc"><span href="#/xhtml/chapter04#ch4" title="Link target outside of Sample">Scarab Sun</span></p>
<p class="toc"><span href="#/xhtml/chapter05#ch5" title="Link target outside of Sample">One God</span></p>
<p class="toc"><span href="#/xhtml/chapter06#ch6" title="Link target outside of Sample">Osiris</span></p>
<p class="toc"><span href="#/xhtml/chapter07#ch7" title="Link target outside of Sample">Isis</span></p>
<p class="toc"><span href="#/xhtml/chapter08#ch8" title="Link target outside of Sample">Mystical Animals</span></p>
<p class="toc"><span href="#/xhtml/chapter09#ch9" title="Link target outside of Sample">The Pyramids</span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Ancient Egypt and the Tarot</span></p>
<p class="toc"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Secrets of the Sphinx</span></p>
<p class="toc"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Sisterhood</span></p>
<p class="toc"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Beauty Rites</span></p>
<p class="toc"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">Medicine or Magic</span></p>
<p class="toc"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Sacred Symbols</span></p>
<p class="toc"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Sacred Stones</span></p>
<p class="toc"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">Glorious Afterlife</span></p>
<p class="toca"><span href="#/xhtml/bm01" title="Link target outside of Sample">ACKNOWLEDGEMENTS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f692d708